// eslint-disable-next-line import/no-cycle
import { decimateDataset } from '~/helpers.js';

// const getMedianYValue = (segment) => {
//     const sortedValues = segment.sort((a, b) => a - b);
//     const middleIndex = Math.floor(sortedValues.length / 2);
//
//     if (sortedValues.length % 2 === 0) {
//         const median = (sortedValues[middleIndex - 1] + sortedValues[middleIndex]) / 2;
//         return median;
//     }
//
//     return sortedValues[middleIndex];
// };

export const decimateData = (data, n) => {
    const decimatedData = [];
    const lastValue = data.at(-1);

    for (let i = 0; i < data.length - 1; i += n) {
        const segment = data.slice(i, i + n);
        const median = segment[0];

        decimatedData.push(median);
    }

    decimatedData.push(lastValue);

    return decimatedData;
};

export const decimatePrice = (dataset, offset) => {
    const updatedDataset = decimateDataset(dataset, offset);

    return {
        ...updatedDataset,
        data: updatedDataset.data.map((y, idx) => ({ x: idx, y })),
    };
};

export const decimateStaking = (dataset, offset) => {
    const updatedDataset = decimateDataset(dataset, offset);

    return {
        ...updatedDataset,
        data: updatedDataset.data.map((y, idx) => ({ x: idx, y })),
    };
};
